<template>
  <!-- TODO: 访客轨迹路径 -->
  <div id='bd-info'>
    <!-- <el-table size="mini" class="bd-info-table" :data="fingerPrints">
      <el-table-column prop="name" label="参数"></el-table-column>
      <el-table-column prop="value" label="值"></el-table-column>
    </el-table> -->
    <el-form ref="form" abel-width="50px" size="mini">
      <el-form-item :label="nameTip">
        <el-link>{{ userCurrentCustomer.name }}</el-link>
      </el-form-item>
      <el-form-item :label="mobileTip">
        <el-link>{{ userCurrentCustomer.mobile }}</el-link>
      </el-form-item>
      <el-form-item :label="emailTip">
        <el-link>{{ userCurrentCustomer.email }}</el-link>
      </el-form-item>
      <el-form-item :label="ageTip">
        <el-link>{{ userCurrentCustomer.age }}</el-link>
      </el-form-item>
      <el-form-item :label="jobTip">
        <el-link>{{ userCurrentCustomer.job }}</el-link>
      </el-form-item>
      <el-form-item :label="companyTip">
        <el-link>{{ userCurrentCustomer.company }}</el-link>
      </el-form-item>
      <el-form-item :label="noteTip">
        <el-link>{{ userCurrentCustomer.description }}</el-link>
      </el-form-item>
      <el-form-item :label="tagTip">
        <el-tag v-for="tag in userCurrentCustomer.tags" :key="tag.tid">{{ tag.name }}</el-tag>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" @click="showEditCrmDrawer">编辑</el-button>
      </el-form-item> -->
    </el-form>
    <!-- TODO: 增加显示设备信息：web/ios/android设备信息 -->
    <!-- <el-tag
      class="bd-user-tags"
      :key="tag.id"
      v-for="tag in tags"
      :closable="true"
      :close-transition="false"
      @close="handleTagDelete(tag.id)">
        {{tag.name}}
    </el-tag>
    <el-input
      class="bd-input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="mini"
      placeholder="回车输入"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm">
    </el-input>
    <el-button v-else size="small" @click="showTagInput">添加标签</el-button> -->
    <!-- <el-dropdown @command="handleCommand" size="small" style="margin-left: 5px;">
      <span class="el-dropdown-link">
        选择标签 <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="a">黄金糕</el-dropdown-item>
        <el-dropdown-item command="b">狮子头</el-dropdown-item>
        <el-dropdown-item command="c">螺蛳粉</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import * as https from '@/apis/http'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-info',
  data () {
    return {
      // 用户信息
      tags: [], //
      //
      inputVisible: false,
      inputValue: ''
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentMonitorThread', 'fingerPrints', 'userCurrentCustomer' ]),
    nameTip () {
      return this.$t('name')
    },
    mobileTip () {
      return this.$t('mobile')
    },
    emailTip () {
      return this.$t('email')
    },
    ageTip () {
      return this.$t('age')
    },
    jobTip () {
      return this.$t('job')
    },
    companyTip () {
      return this.$t('company')
    },
    noteTip () {
      return this.$t('note')
    },
    tagTip () {
      return this.$t('tag')
    }
  },
  methods: {
    ...mapActions([ 'fingerPrint', 'userTag' ]),
    showEditCrmDrawer () {
      // console.log('showEditCrmDrawer')
      bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER)
    },
    handleTagDelete (tagid) {
      console.log('handleTagDelete:', tagid)
      //
    },
    showTagInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      console.log('handleInputConfirm:', this.inputValue)
      let tagName = this.inputValue
      if (tagName) {
        //
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleCommand (command) {
      this.$message('click on item ' + command)
    }
  }
}
</script>

<style scoped>
#bd-info {
  height: 100%;
  width: 100%;
  text-align: left;
}
.bd-info-table {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 100%;
  overflow-y: scroll !important;
}
.bd-user-tags {
  margin-top: 20px;
  margin-right: 5px;
}
.bd-input-new-tag{
  width:78px;
  margin-top: 20px;
  margin-left: 5px;
  vertical-align:bottom;
}
.bd-new-tag {
  margin-top: 20px;
  margin-left:10px;
}
</style>
